import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useConsolidationExportUIContext } from "./ConsolidationExportUIContext";
import { ConsolidationExportFilter } from "./consolidation-export-table/consolidation-export-filter/ConsolidationExportFilter";
// import ConsolidationExportDetail from "./consolidation-export-detail/ConsolidationExportDetail";
import { fetchConsolidationExports } from "../../_redux/consolidation-export/consolidation-export-action";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import ConsolidationExportTable from "./consolidation-export-table/ConsolidationExportTable";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import { ConfirmationModal } from "../../../Donation/pages/confirmation/confirmation-edit/confirmation-edit-form/ConfirmationModal";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import moment from "moment";
import { Collapse } from "react-bootstrap";
import { exportConsolidation } from "../../_redux/consolidation-export/consolidation-export-crud";
import ConsolidationExportFileModal from "./consolidation-export-file-modal/ConsolidationExportFileModal";

export const ConsolidationExportCard = ({
  match: {
    params: { id }
  },
  history
}) => {
  // * DECLARE HOOKS
  const dispatch = useDispatch();
  const [modal, setModal] = useState({
    exportModal: false
  });
  const [loading, setLoading] = useState(false);

  // * ConsolidationExport UI Context
  const ConsolidationExportUIContext = useConsolidationExportUIContext();
  const ConsolidationExportUIProps = useMemo(() => {
    return {
      queryParams: ConsolidationExportUIContext.queryParams,
      setQueryParams: ConsolidationExportUIContext.setQueryParams,
      openEditConsolidationExportPage:
        ConsolidationExportUIContext.openEditConsolidationExportPage,
      openConsolidationExportFilePage:
        ConsolidationExportUIContext.openConsolidationExportFilePage
    };
  }, [ConsolidationExportUIContext]);

  // * Getting curret state of ConsolidationExport list from store (Redux)
  const {
    totalCount,
    entities = [],
    listLoading,
    actionsLoading
  } = useSelector(state => state.superAdminConsolidationExport, shallowEqual);

  useEffect(() => {
    // * Requset ke ConsolidationExport Action
    dispatch(fetchConsolidationExports(ConsolidationExportUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ConsolidationExportUIProps.queryParams, dispatch]);

  const exportConsolidationData = async value => {
    setLoading(true);
    await exportConsolidation(ConsolidationExportUIProps.queryParams)
      .then(res => {
        const url = URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", `${value.filename}.xlsx`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(err => {
        toast.error("Gagal export data Lembaga");
      })
      .then(() => {
        setLoading(false);
        setModal(prev => ({ ...prev, exportModal: false }));
      });
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading || loading} />
      <ConsolidationExportFileModal
        show={modal.exportModal}
        onHide={() => setModal(prev => ({ ...prev, exportModal: false }))}
        onClick={exportConsolidationData}
        title="Export Konsolidasi"
        initialValues={{
          filename: `Konsolidasi ${new Date().getFullYear()}`
        }}
      />
      <Card>
        <CardHeader title="Laporan Konsolidasi">
          <CardHeaderToolbar>
            <button
              className="btn btn-outline-dark"
              onClick={() => setModal(prev => ({ ...prev, exportModal: true }))}
            >
              Export Konsolidasi
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <ConsolidationExportFilter />
          <ConsolidationExportTable
            totalCount={totalCount}
            listLoading={listLoading}
            entities={entities}
            queryParams={ConsolidationExportUIProps.queryParams}
            setQueryParams={ConsolidationExportUIProps.setQueryParams}
            openEditConsolidationExportPage={
              ConsolidationExportUIProps.openEditConsolidationExportPage
            }
          />
        </CardBody>
      </Card>
    </>
  );
};
